export default function MarqueeBanner() {
  const items = Array(8).fill("Better Than Yesterday");

  return (
    <section
      data-testid="marquee-banner"
      className="py-5 sm:py-6 bg-[#0A0A0A] overflow-hidden"
    >
      <div className="flex animate-marquee whitespace-nowrap">
        {items.map((text, i) => (
          <span
            key={i}
            className="mx-8 sm:mx-12 text-lg sm:text-xl lg:text-2xl tracking-[0.15em] uppercase text-white/90"
          >
            {text}
            <span className="mx-8 sm:mx-12 text-white/30">/</span>
          </span>
        ))}
        {items.map((text, i) => (
          <span
            key={`dup-${i}`}
            className="mx-8 sm:mx-12 text-lg sm:text-xl lg:text-2xl tracking-[0.15em] uppercase text-white/90"
          >
            {text}
            <span className="mx-8 sm:mx-12 text-white/30">/</span>
          </span>
        ))}
      </div>
    </section>
  );
}
